/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpgradeCertificateRequest
 */
export interface CreateUpgradeCertificateRequest {
    /**
     * Link to a loyalty account if applicable
     * @type {string}
     * @memberof CreateUpgradeCertificateRequest
     */
    loyaltyAccountId?: string | null;
    /**
     * e.g. Marriott Bonvoy, World of Hyatt
     * @type {string}
     * @memberof CreateUpgradeCertificateRequest
     */
    programName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpgradeCertificateRequest
     */
    certificateType: CreateUpgradeCertificateRequestCertificateTypeEnum;
    /**
     * Total certificates earned
     * @type {number}
     * @memberof CreateUpgradeCertificateRequest
     */
    totalCount: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpgradeCertificateRequest
     */
    expirationDate: Date;
    /**
     * Optional notes about these certificates
     * @type {string}
     * @memberof CreateUpgradeCertificateRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const CreateUpgradeCertificateRequestCertificateTypeEnum = {
    Nua: 'nua',
    Sua: 'sua',
    Cur: 'cur',
    IhgSuiteUpgrade: 'ihg_suite_upgrade'
} as const;
export type CreateUpgradeCertificateRequestCertificateTypeEnum = typeof CreateUpgradeCertificateRequestCertificateTypeEnum[keyof typeof CreateUpgradeCertificateRequestCertificateTypeEnum];


/**
 * Check if a given object implements the CreateUpgradeCertificateRequest interface.
 */
export function instanceOfCreateUpgradeCertificateRequest(value: object): value is CreateUpgradeCertificateRequest {
    if (!('programName' in value) || value['programName'] === undefined) return false;
    if (!('certificateType' in value) || value['certificateType'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    return true;
}

export function CreateUpgradeCertificateRequestFromJSON(json: any): CreateUpgradeCertificateRequest {
    return CreateUpgradeCertificateRequestFromJSONTyped(json, false);
}

export function CreateUpgradeCertificateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpgradeCertificateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'],
        'certificateType': json['certificate_type'],
        'totalCount': json['total_count'],
        'expirationDate': (new Date(json['expiration_date'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateUpgradeCertificateRequestToJSON(json: any): CreateUpgradeCertificateRequest {
    return CreateUpgradeCertificateRequestToJSONTyped(json, false);
}

export function CreateUpgradeCertificateRequestToJSONTyped(value?: CreateUpgradeCertificateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'certificate_type': value['certificateType'],
        'total_count': value['totalCount'],
        'expiration_date': value['expirationDate'].toISOString().substring(0,10),
        'notes': value['notes'],
    };
}

